import { accountsEnvironment } from '../accounts-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { companySchema } from '../schemas/company.schema';
import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

const requestSchema = companySchema
  .pick({
    alias: true,
    externalAccountId: true,
    products: true,
  })
  .required({
    products: true,
  });

/**
 * Used by a Trimble Maps Partner to assign mobile or web products to a company
 * @param alias Alias of the Company
 * @param externalAccountId External Account ID of the Company
 * @param products.mobileProducts Array of Mobile Products to assign
 * @param products.webProducts Array of Web Products to assign
 * @returns Data object indicating success
 */
export function postCompanyProducts(
  this: unknown,
  request: z.infer<typeof requestSchema>
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(`${accountsEnvironment.resolve(this).companyUrl}/products`, {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
        body: JSON.stringify(request),
      })
    )
  ).pipe(
    selectData(
      z.object({
        href: z.string().nullable(),
        data: z.boolean(),
      })
    )
  );
}
